import * as React from "react";

interface IProps {
    wordingHtml: JSX.Element;
}

export class HeadsUpPanel extends React.Component<IProps> {

    constructor(props: IProps) {
        super(props);
    }

    public render() {
        return (
            <div className="section-panel banner banner-info">
                {this.props.wordingHtml}
            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./src/components/HeadsUpPanel.tsx